import * as React from 'react';
import { useRouter } from 'next/router';

import { Spinner } from '@restworld/ui-ds';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IFallbackSpinnerProps {}

export const FallbackSpinner: React.FunctionComponent<IFallbackSpinnerProps> = (props) => {
  const { isFallback } = useRouter();

  return isFallback ? <Spinner color="primary" size="lg" withBackDrop /> : null;
};

export default FallbackSpinner;
